import actionTypes from "../actionTypes";

const update = require('immutability-helper');


export const initialState = {
    seccion: 'datos_personales',
    idioma: 'es'
};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {
        case 'choose-config-section':
            return update(state, {seccion: {$set: action.seccion}});
        case 'choose-config-idioma':
            return update(state, {idioma: {$set: action.idioma}});
        default:
            return state
    }
}